import React, { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { updatePage, getPageDataWithId } from "adminApi/PageApi/Page";
import { validateForm } from "utils/validation";
import Spinner from "Common/Globle/Spinner";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import fields from "../json/PagesFields.json";
import PageForm from "../AddPage/Components/PageForm";

const PageRules = {
    name: [
        { rule: "required", label: "Title" },
        { rule: "minLength", value: 2, label: "Title" },
    ],
    slug: [
        { rule: "required", label: "Slug" },
    ],
    content: [
        { rule: "required", label: "Content" },
    ],
};

const EditPage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    const initialValues = formdata.reduce((acc, field) => ({
        ...acc,
        [field.name]: field.type === "switch" ? "1" : "",
    }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(initialValues, PageRules);

    const customGetPageDataWithId = useCallback(async (pageId) => {
        const res = await getPageDataWithId(pageId);
        if (res?.data?.success && res.data.data) {
            const pageData = res.data.data;
            // Convert status to string for switch component
            pageData.status = String(pageData.status);
            // Content comes as { html: "..." } object from the API — extract the HTML string
            if (pageData.content && typeof pageData.content === "object" && pageData.content.html) {
                pageData.content = pageData.content.html;
            }
        }
        return res;
    }, []);

    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, customGetPageDataWithId, setValues);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await updatePage({ id, data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, PageRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Page updated successfully"
    );

    return (
        <>
            {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
            <PageForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Edit Page"
                submitLabel="Update Page"
            />
        </>
    );
};

export default EditPage;
